/**
 * Typed client for /api/platform/* read-only endpoints.
 *
 * Mirrors hy_sales/schemas/platform_config.py — keep in lockstep.
 */

import { apiGet } from './client';

export interface LockedSectionsResponse {
  locked: string[];
}

export function fetchLockedSections(): Promise<LockedSectionsResponse> {
  return apiGet<LockedSectionsResponse>('sales', '/api/platform/locked-sections');
}
